import TextArea from 'antd/lib/input/TextArea';
import './CallPanel.scss';

const MAX_LENGTH = 2000;

interface IProps {
  textArea: any;
  saving: boolean;
  inputEvent: (e: any) => void;
  currentNote: string;
}

export const NoteBlock = ({
  textArea,
  saving,
  inputEvent,
  currentNote,
}: IProps) => {
  return (
    <div className="note__main">
      <div className="main-text note__header">Write a note</div>
      <div className="note__textarea-wrapper">
        <div className="note__textarea">
          <TextArea
            data-testid="note-textarea"
            ref={textArea}
            autoSize={{ minRows: 5 }}
            showCount
            maxLength={MAX_LENGTH}
            disabled={saving}
            onChange={(e) => inputEvent(e)}
            placeholder="Please, write a phone call note"
            value={currentNote}
          ></TextArea>
        </div>
      </div>
    </div>
  );
};
